import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import { Box, Group } from '@mantine/core';
import Button from '../../../new_arch/components/Button/Button';
import Text from '../../../new_arch/modules/ui/components/Text/Text';
import PlanSettingsPresenter from '../../../presenters/PlanSettings/PlanSettingsPresenter';
import { PlanDetails } from '../ActiveSubscriptionDetail/ActiveSubscriptionDetail';
import { STRONG_ERROR } from '../../../styles/colors';

const SuspendedHeader = ( { presenter } ) => (
	<Group position="apart" align="center" noWrap>
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
			<Text variant="body-bold" style={{ letterSpacing: 0, color: 'var(--color-text-primary)' }}>
				{presenter.workspace.isOnExpiredFreeTrial
					? <>Your trial has ended, so your workspace has been <Text component="span" variant="body-bold" style={{ color: STRONG_ERROR, letterSpacing: 0 }}>Suspended</Text>.</>
					: <>Your workspace has been <Text component="span" variant="body-bold" style={{ color: STRONG_ERROR, letterSpacing: 0 }}>Suspended</Text>.</>}
			</Text>
			<Text variant="body-bold" style={{ letterSpacing: 0, color: 'var(--color-text-primary)' }}>Select a plan to reactivate it.</Text>
		</Box>
		<Button
			style={{ width: '137px', height: '40px', padding: '0 32px', flexShrink: 0 }}
			size="md"
			type="primary"
			onClick={presenter.onUpgradePlanButtonClicked}
		>
			{presenter.upgradeButtonData.text}
		</Button>
	</Group>
);

SuspendedHeader.propTypes = {
	presenter: PropTypes.instanceOf( PlanSettingsPresenter ).isRequired
};

const SuspendedSubscriptionDetail = ( { presenter } ) => (
	<Box
		sx={{
			display: 'flex',
			flexDirection: 'column',
			gap: '24px',
			padding: '24px',
			borderRadius: '24px',
			border: '2px solid var(--color-outline-default)',
			backgroundColor: 'var(--color-bg-container)',
			width: '100%',
			maxWidth: '744px',
			boxSizing: 'border-box'
		}}
	>
		<SuspendedHeader presenter={presenter} />
		<PlanDetails presenter={presenter} />
	</Box>
);

SuspendedSubscriptionDetail.propTypes = {
	presenter: PropTypes.instanceOf( PlanSettingsPresenter ).isRequired
};

export default observer( SuspendedSubscriptionDetail );
